import React from 'react';

import styles from './InputRadioList.module.css';

type Button = {
  value: string;
  label: string;
}

interface Props {
  title: string,
  buttons: Button[],
  name?: string,
  selected?: string,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  className?: string,
  disabled?: boolean,
  error?: string;
}

export default function InputRadioList({
  title, buttons, name, selected, onChange, className, disabled, error
}: Props) {
  return (
    <div className={`${styles.input} ${className}`}>
      <p className={styles.label}>{title}</p>
      <div className={styles.list}>
        {
          buttons.map((button) => (
            <label
              key={button.value}
              htmlFor={button.value}
              className={`${styles.select} ${(selected === button.value) ? styles.checked : ''} ${disabled ? styles.disabled : ''}`}
              data-cy={`${name}-${button.value}`}
            >
              <input
                type="radio"
                id={button.value}
                name={name}
                value={button.value}
                checked={selected === button.value}
                onChange={onChange}
                disabled={disabled}
                data-cy={`${name}-${button.value}-input`}
              />
              {button.label}
            </label>
          ))
        }
      </div>
    </div>
  );
}
